/** Czech translations (default language, §12). */
export const cs = {
  app: {
    name: 'uSolar',
    tagline: 'Monitoring a správa fotovoltaických elektráren',
    loading: 'Načítám…',
    retry: 'Zkusit znovu',
    save: 'Uložit',
    cancel: 'Zrušit',
    close: 'Zavřít',
    logout: 'Odhlásit',
    language: 'Jazyk',
    tenant: 'Zákazník',
    noData: 'Nejsou k dispozici data',
    unknown: 'neznámé',
    table: 'Tabulka',
    chart: 'Graf',
  },
  nav: {
    portfolio: 'Portfolio',
    plants: 'Elektrárny',
    compare: 'Porovnání',
    incidents: 'Incidenty',
    admin: 'Konektory',
    reports: 'Reporty',
    mis: 'Manažerský přehled',
  },
  login: {
    title: 'Přihlášení',
    email: 'E-mail',
    password: 'Heslo',
    submit: 'Přihlásit se',
    mfaTitle: 'Druhý faktor',
    mfaHint: 'Zadejte šestimístný kód z aplikace (nebo záložní kód).',
    mfaCode: 'Kód',
    mfaSubmit: 'Potvrdit',
    enrollTitle: 'Nastavení dvoufaktorového ověření',
    enrollHint:
      'Vaše role vyžaduje dvoufaktorové ověření. Naskenujte QR kód autentizační aplikací, nebo do ní zadejte tajný klíč ručně, a potvrďte vygenerovaným kódem.',
    enrollQr: 'Naskenujte QR kód autentizační aplikací',
    enrollQrAlt: 'QR kód s odkazem otpauth, který je níže vypsaný i textem',
    enrollSecret: 'Tajný klíč',
    enrollUri: 'Odkaz otpauth',
    recoveryTitle: 'Záložní kódy',
    recoveryHint:
      'Uložte si tyto kódy na bezpečné místo. Každý lze použít jednou a znovu je nezobrazíme.',
    recoveryDone: 'Mám je uložené, pokračovat',
    selectTenant: 'Vyberte zákazníka',
  },
  kpi: {
    currentPower: 'Okamžitý výkon',
    energyToday: 'Výroba dnes',
    specificYield: 'Specifická výroba',
    dcCapacity: 'Instalovaný výkon DC',
    irradiance: 'Osvit',
    temperature: 'Teplota modulů',
    devices: 'Zařízení',
    openIncidents: 'Otevřené incidenty',
    plants: 'Elektrárny',
    reporting: 'hlásí aktuální data',
    coverage: 'Pokrytí dat',
    energyMethod: {
      counter: 'z počítadla střídače',
      integral: 'integrací výkonu',
      mixed: 'kombinovaně',
    },
  },
  freshness: {
    online: 'aktuální',
    stale: 'zastaralé',
    offline: 'offline',
    unknown: 'bez dat',
    error: 'chyba zařízení',
    ageSeconds: 'stáří {{value}} s',
    ageMinutes: 'stáří {{value}} min',
    ageHours: 'stáří {{value}} h',
    never: 'nikdy nehlásilo',
    tooltip: 'Čas zdroje: {{sampleTime}} · očekávaný cyklus {{cycle}} s',
  },
  plant: {
    title: 'Elektrárna',
    devices: 'Zařízení',
    production: 'Výroba a výkon',
    incidents: 'Incidenty',
    report: 'Denní report',
    noIrradiance: 'Elektrárna nemá čidlo osvitu — hodnota osvitu není měřena.',
    capacityUnknown: 'Instalovaný výkon není zadán, specifickou výrobu nelze spočítat.',
    partialPower: 'Součet výkonu nezahrnuje zařízení bez aktuálních dat.',
  },
  device: {
    name: 'Zařízení',
    kind: 'Typ',
    status: 'Stav',
    power: 'Výkon',
    energyTotal: 'Celková výroba',
    sampleTime: 'Čas měření',
    sourceTime: 'Čas ze zdroje',
    ingestedAt: 'Čas uložení',
    quality: 'Kvalita',
    serial: 'Výrobní číslo',
    capacity: 'Výkon DC',
    section: 'Okruh',
    errorCode: 'Chybový kód',
    statusCode: 'Provozní stav',
    kinds: {
      inverter: 'střídač',
      irradiance_sensor: 'čidlo osvitu',
      temperature_sensor: 'čidlo teploty',
      meter: 'měřidlo',
      logger: 'datalogger',
      breaker: 'jistič',
      other: 'jiné',
    },
    qualities: {
      good: 'platné',
      stale: 'zastaralé',
      estimated: 'odhad',
      suspect: 'podezřelé',
      error: 'chyba',
    },
    noSourceTime: 'zdroj neposkytuje',
  },
  chart: {
    power: 'Výkon (kW)',
    energy: 'Energie (kWh)',
    irradiance: 'Osvit (W/m²)',
    normalized: 'Normalizováno na kWp',
    resolution: 'Rozlišení',
    range: 'Období',
    exportCsv: 'Export CSV',
    ranges: {
      today: 'Dnes',
      yesterday: 'Včera',
      week: '7 dní',
      month: '30 dní',
      year: 'Rok',
    },
    resolutions: {
      raw: 'surová data',
      '5min': '5 min',
      '15min': '15 min',
      hour: 'hodina',
      day: 'den',
      month: 'měsíc',
    },
  },
  compare: {
    title: 'Porovnání zařízení a okruhů',
    hint: 'Vyberte zařízení ke srovnání ve stejném časovém okně.',
    normalize: 'Normalizovat na instalovaný výkon (kWp)',
    capacityUnknown: 'U některých zařízení není znám instalovaný výkon — zobrazeny absolutní hodnoty.',
    selectDevices: 'Zařízení',
    run: 'Porovnat',
  },
  incidents: {
    title: 'Incidenty',
    openOnly: 'Jen otevřené',
    severity: 'Závažnost',
    opened: 'Vznik',
    device: 'Zařízení',
    status: 'Stav',
    evidence: 'Podklady',
    acknowledge: 'Převzít',
    closeIncident: 'Uzavřít',
    resolution: 'Řešení',
    rootCause: 'Příčina',
    none: 'Žádné incidenty',
    severities: { info: 'informace', warning: 'varování', major: 'závažný', critical: 'kritický' },
    statuses: {
      new: 'nový',
      assigned: 'přidělený',
      in_progress: 'řeší se',
      waiting: 'čeká',
      closed: 'uzavřený',
    },
    resolutions: {
      fixed: 'opraveno',
      false_alarm: 'falešný poplach',
      curtailment: 'regulace výkonu',
      no_fault_found: 'závada nenalezena',
      deferred: 'odloženo',
      other: 'jiné',
      auto_cleared: 'automaticky odpadlo',
    },
    rules: {
      'comm.source_unreachable': 'Datalogger {{source}} neodpovídá',
      'device.offline': 'Zařízení {{device}} nehlásí data',
      'device.error_code': 'Zařízení {{device}} hlásí chybu {{code}}',
      'device.zero_production': 'Zařízení {{device}} nevyrábí, zatímco okolní střídače vyrábějí',
    },
    suspicionNotice:
      'Jde o podezření z dat, nikoli o prokázanou závadu. Před výměnou komponent doporučujeme kontrolu na místě.',
  },
  admin: {
    title: 'Datové zdroje (konektory)',
    readOnlyNotice:
      'Všechny konektory jsou v režimu pouze pro čtení. Systém neumí zapisovat ani spínat technologii.',
    endpoint: 'Adresa',
    connector: 'Konektor',
    interval: 'Interval dotazu',
    lastSuccess: 'Poslední úspěch',
    failures: 'Chyby za sebou',
    probe: 'Ověřit dostupnost',
    poll: 'Načíst nyní',
    runs: 'Historie načtení',
    probeOk: 'Logger odpověděl ({{latency}} ms)',
    probeFail: 'Logger neodpověděl: {{detail}}',
    pollDone: 'Načteno: {{samples}} hodnot z {{devices}} zařízení',
  },
  report: {
    title: 'Denní report',
    date: 'Datum',
    energy: 'Výroba',
    coverage: 'Pokrytí',
    method: 'Metoda',
    downloadCsv: 'Stáhnout CSV',
    disclaimers: {
      partial_coverage: 'Report nepokrývá celé období — část dat chybí.',
      coverage_unknown: 'Pokrytí dat nelze určit.',
      dc_capacity_unknown: 'Není zadán instalovaný výkon, specifická výroba chybí.',
      energy_partly_integrated_from_power:
        'Část energie byla spočítána integrací výkonu, ne z počítadla střídače.',
    },
  },
  mis: {
    periods: {
      this_month: 'Tento měsíc',
      last_month: 'Minulý měsíc',
      this_quarter: 'Toto čtvrtletí',
      this_year: 'Tento rok',
      last_12_months: '12 měsíců',
      custom: 'Vlastní',
    },
    energy: 'Výroba',
    energyKwh: 'Výroba (kWh)',
    plantCount_one: '{{count}} elektrárna',
    plantCount_few: '{{count}} elektrárny',
    plantCount_many: '{{count}} elektrárny',
    plantCount_other: '{{count}} elektráren',
    peakPower: 'Špičkový výkon',
    dataAvailability: 'Dostupnost dat',
    availabilityHint: 'Podíl očekávaných měření, která jsme dostali.',
    performanceRatio: 'Performance ratio',
    incidentsOpened: 'Vzniklé incidenty',
    closed: 'uzavřeno',
    mtta: 'MTTA (čas do převzetí)',
    mttr: 'MTTR (čas do vyřešení)',
    trend: 'Vývoj výroby',
    monthlyEnergy: 'Měsíční výroba',
    month: 'Měsíc',
    ranking: 'Srovnání elektráren',
    rankingExcluded_one: 'Mimo srovnání zůstává {{count}} elektrárna bez zadaného instalovaného výkonu.',
    rankingExcluded_few: 'Mimo srovnání zůstávají {{count}} elektrárny bez zadaného instalovaného výkonu.',
    rankingExcluded_many: 'Mimo srovnání zůstává {{count}} elektrárny bez zadaného instalovaného výkonu.',
    rankingExcluded_other: 'Mimo srovnání zůstává {{count}} elektráren bez zadaného instalovaného výkonu.',
    capacityMissing_one: '{{count}} elektrárna bez instalovaného výkonu',
    capacityMissing_few: '{{count}} elektrárny bez instalovaného výkonu',
    capacityMissing_many: '{{count}} elektrárny bez instalovaného výkonu',
    capacityMissing_other: '{{count}} elektráren bez instalovaného výkonu',
    service: 'Servisní ukazatele',
    byRule: 'Podle pravidla',
    rule: 'Pravidlo',
    noData: 'nemáme data',
    notAvailable: 'nelze spočítat',
    minutes: '{{value}} min',
    hours: '{{value}} h',
    days: '{{value}} dní',
    generatedAt: 'Sestaveno {{value}}',
    ruleNames: {
      'comm.source_unreachable': 'Nedostupný datalogger',
      'device.offline': 'Zařízení nehlásí data',
      'device.error_code': 'Chybový kód zařízení',
      'device.zero_production': 'Nulová výroba proti sousedům',
    },
    notes: {
      availability_is_data_based:
        'Dostupnost zde znamená dostupnost dat, ne technickou disponibilitu elektrárny — tu lze spočítat až s modelem očekávané výroby (Fáze 3).',
      no_irradiance_sensor:
        'Žádná z elektráren nemá čidlo osvitu, proto se nepočítá performance ratio.',
      irradiance_coverage_low:
        'Čidlo osvitu neposlalo za období dost dat, performance ratio proto neuvádíme.',
      irradiance_partial: 'Měření osvitu je za období neúplné.',
      partial_coverage: 'U části období chybí data — čísla jsou dílčí.',
      dc_capacity_unknown:
        'U některých elektráren není zadán instalovaný výkon; specifická výroba a PR u nich chybí.',
      energy_partly_integrated_from_power:
        'Část energie je dopočítaná integrací výkonu, ne z počítadla střídače.',
      devices_without_data: 'Část zařízení za období nehlásila žádná data.',
      months_without_data:
        'Měsíce bez dat jsou v grafu prázdné — neznamenají nulovou výrobu.',
    },
  },
  errors: {
    'auth.unauthorized': 'Nejste přihlášeni.',
    'auth.invalid_credentials': 'Neplatný e-mail nebo heslo.',
    'auth.account_locked': 'Účet je dočasně zablokován po opakovaných pokusech.',
    'auth.account_disabled': 'Účet je deaktivován.',
    'auth.rate_limited': 'Příliš mnoho pokusů. Zkuste to za chvíli.',
    'auth.mfa_required': 'Je potřeba dokončit dvoufaktorové ověření.',
    'auth.mfa_invalid_code': 'Neplatný kód.',
    'auth.mfa_not_started': 'Nastavení druhého faktoru nebylo zahájeno.',
    'auth.mfa_already_enabled': 'Dvoufaktorové ověření je už aktivní.',
    'auth.forbidden': 'K této akci nemáte oprávnění.',
    'auth.permission_denied': 'K této akci nemáte oprávnění ({{permission}}).',
    'auth.tenant_not_selected': 'Vyberte zákazníka.',
    'auth.tenant_not_allowed': 'K tomuto zákazníkovi nemáte přístup.',
    'auth.csrf_failed': 'Vypršela relace. Obnovte stránku a zkuste to znovu.',
    'resource.not_found': 'Záznam nebyl nalezen.',
    'plant.not_found': 'Elektrárna nebyla nalezena.',
    'device.not_found': 'Zařízení nebylo nalezeno.',
    'incident.not_found': 'Incident nebyl nalezen.',
    'incident.already_closed': 'Incident je už uzavřený.',
    'telemetry.invalid_range': 'Neplatné časové období.',
    'telemetry.range_too_large': 'Období je příliš dlouhé (max {{max_days}} dní pro toto rozlišení).',
    'telemetry.unknown_metric': 'Neznámá metrika.',
    'report.future_date': 'Report nelze vytvořit pro budoucí datum.',
    'request.invalid': 'Neplatný požadavek.',
    'server.error': 'Chyba serveru. Zkuste to prosím znovu.',
    generic: 'Něco se nepovedlo ({{code}}).',
  },
};
